import { MixedLineBarChartProps } from '@amzn/awsui-components-core';
import { CostMetricsTableData } from './CostMetricsInterface';

interface CostMetricsAggregatedData {
  costMetricsTrendsByMonthGraphData: MixedLineBarChartProps.BarDataSeries<string | number | Date>[];
  costByResourceTypeGraphData: MixedLineBarChartProps.LineDataSeries<string | number | Date>[];
  costByApplicationGraphData: MixedLineBarChartProps.LineDataSeries<string | number | Date>[];
  aggregatedCostByAccountDetailsTable: CostMetricsTableData;
  aggregatedCostByProductDetailsTable: CostMetricsTableData;
}

export const aggregateCostMetricsSummaryData = (costMetricsData: CostMetricsAggregatedData) => {
  // Aggregate cost metrics data for AI summary
  return {
    costMetricsTrendsByMonth: costMetricsData.costMetricsTrendsByMonthGraphData || [],
    costByResourceType: costMetricsData.costByResourceTypeGraphData || [],
    costByApplication: costMetricsData.costByApplicationGraphData || [],
    aggregatedCostByAccountDetailsTable: costMetricsData.aggregatedCostByAccountDetailsTable || ({} as CostMetricsTableData),
    aggregatedCostByProductDetailsTable: costMetricsData.aggregatedCostByProductDetailsTable || ({} as CostMetricsTableData)
  };
};
